module.exports = __webpack_public_path__ + "img/ja.80594ff1.svg";